const normalize = (str: string) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeLowerCase = (str: string) => normalize(str).toLowerCase();

export default {
  normalize,
  normalizeLowerCase,
};
